/**
 * @desc 修改
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ListingQuoteUpdateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/listingQuote/update/ListingQuoteUpdateRequestDto`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
